import { useQuery } from "@tanstack/react-query";
import { SubCategoryService } from "../../services";
import { asQuery } from "../../services/common";
import { ONE_HOUR } from "./shared";

// Sub-categories for a parent category — paused until a categoryId is provided.
export function useSubCategories(categoryId?: string) {
  return useQuery({
    queryKey: ["sub-categories", "by-parent", categoryId],
    queryFn: () =>
      asQuery<any[]>(
        SubCategoryService.getByParentCategory({ categoryId, keyword: "" }),
      ),
    enabled: !!categoryId,
    staleTime: ONE_HOUR,
  });
}

// A single sub-category by id (token-gated) — paused until an id is provided.
export function useSubCategory(id?: string, token?: string) {
  return useQuery({
    queryKey: ["sub-categories", id],
    queryFn: () =>
      asQuery<any>(SubCategoryService.getById(id as string, token as string)),
    enabled: !!id && !!token,
    staleTime: ONE_HOUR,
  });
}
